import React from "react"

interface FormErrorsTopProps {
  errors?: Record<string, string[] | string> | string[] | string | null
  className?: string
}

const FormErrorsTop: React.FC<FormErrorsTopProps> = ({ errors, className }) => {
  if (!errors) return null

  // Normalize errors into an array of strings
  const flattened = Array.isArray(errors)
    ? errors
    : typeof errors === "string"
      ? [errors]
      : Object.values(errors).flatMap((e) => (Array.isArray(e) ? e : [e]))

  if (flattened.length === 0) return null

  return (
    <div
      role="alert"
      aria-live="assertive"
      className={`bg-red-50 border border-red-200 rounded-lg mb-4 flex gap-3 ${className || ""}`}
    >
      <svg
        className="w-5 h-5 shrink-0 text-red-600"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-11.5a.75.75 0 10-1.5 0v4a.75.75 0 001.5 0v-4zm0 6a.75.75 0 10-1.5 0 .75.75 0 001.5 0z"
          clipRule="evenodd"
        />
      </svg>

      <div className="flex-1">
        <p className="font-semibold text-red-800 m-0">
          Please fix the following {flattened.length > 1 ? "errors" : "error"}:
        </p>
        <ul className="mt-2 list-disc list-inside space-y-1 text-sm text-red-700">
          {flattened.map((msg, i) => (
            <li key={i}>{msg}</li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default FormErrorsTop
